import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ExtrapagesRoutingModule } from './extrapages-routing.module';
import { Basic404Component } from './basic404/basic404.component';
import { Cover404Component } from './cover404/cover404.component';
import { Cover500Component } from './cover500/cover500.component';
import { Basic500Component } from './basic500/basic500.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { ComingsoonComponent } from './comingsoon/comingsoon.component';
import { TranslateModule } from '@ngx-translate/core';
import { Basic401Component } from './basic401/basic401.component';
import { SharedModule } from '@shared';

@NgModule({
  exports: [MaintenanceComponent],
  declarations: [
    Basic404Component,
    Cover404Component,
    Cover500Component,
    Basic500Component,
    MaintenanceComponent,
    ComingsoonComponent,
    Basic401Component,
  ],
  imports: [CommonModule, ExtrapagesRoutingModule, TranslateModule, SharedModule],
})
export class ExtrapagesModule {}
